//

export const pluralize = (singular, plural, count) => {
  if (count === 1) {
    return `${count} ${singular}`;
  }

  return `${count} ${plural}`;
};
